module.exports = __webpack_public_path__ + "static/media/systembolaget_logo.25a27d5e.jpg";